import React from 'react';
import ReactDOM from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import './index.css';
import App from './App';
import { store } from "./Store";
import { Provider } from "react-redux";
import { ChakraProvider } from '@chakra-ui/react';
import theme from './theme';
import { FeaturesProvider } from './contexts/ThemeContext';
import { DomainProvider } from './contexts/DomainContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DomainProvider>
    <ChakraProvider theme={theme}>
      <Provider store={store}>
      <FeaturesProvider>
        <App />
      </FeaturesProvider>
      </Provider>
    </ChakraProvider>
    </DomainProvider>
  </React.StrictMode>
);
